<template>
  <div class="act_layout flower_head_panel" data-guide="flower-head-panel">
    <div class="size_control" data-guide="flower-head-size-control">
      <span class="control_label">大小</span>
      <van-slider
        class="size_slider"
        v-model="size"
        @input="handleInput"
        @change="renderRealScene"
        :min="0.5"
        :max="2"
        :step="0.1"
        bar-height="4px"
        inactive-color="#999"
        active-color="#6e9f21"
      />
    </div>
    <div class="direction_control" data-guide="flower-head-direction-control">
      <button type="button" class="direction_arrow direction_arrow_left" @click="turn(-1)" aria-label="向左切换花头朝向">
        <span></span>
      </button>
      <div class="direction_value">
        {{ rAngle }}角度
      </div>
      <button type="button" class="direction_arrow direction_arrow_right" @click="turn(1)" aria-label="向右切换花头朝向">
        <span></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      size: 1,
      id: "",
      rAngle: 1,
    };
  },
  methods: {
    turn(type) {
      this.$bus.$emit("guide-control-change", {
        key: "flowerHeadDirection",
      });
      this.$bus.$emit("rotate", {
        val: type,
        id: this.id,
      });
    },
    init(item) {
      this.rAngle = item.faceIndex;
      this.id = item.id;
      this.size = item.size;
    },
    handleInput() {
      if (!this.id) {
        return;
      }
      this.$bus.$emit("guide-control-change", {
        key: "flowerHeadSize",
      });
      this.$bus.$emit("setSize", {
        id: this.id,
        value: this.size,
      });
    },
    renderRealScene() {
      this.$bus.$emit("renderRealScene");
    },
  },
  created() {
    this.$bus.$on("rotate-result", (val) => {
      this.rAngle = val;
    });
  },
};
</script>

<style lang="scss" scoped>
.flower_head_panel {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: rem(42);
  min-height: rem(76);
  padding: 0 rem(34);
}

.size_control {
  display: flex;
  align-items: center;
  flex: 1;
  max-width: rem(520);
  min-width: rem(320);
}

.control_label {
  flex-shrink: 0;
  color: #29312b;
  font-size: rem(26);
  font-weight: bold;
}

.size_slider {
  flex: 1;
  margin-left: rem(22);
}

.direction_control {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: rem(18);
}

.direction_arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: rem(52);
  height: rem(52);
  padding: 0;
  border: 1px solid #cdd8b7;
  border-radius: 50%;
  background: rgba(248, 250, 243, 0.92);
  box-sizing: border-box;

  span {
    width: rem(16);
    height: rem(16);
    border-top: rem(4) solid #6e9f21;
    border-right: rem(4) solid #6e9f21;
  }
}

.direction_arrow_left span {
  transform: rotate(-135deg);
  margin-left: rem(6);
}

.direction_arrow_right span {
  transform: rotate(45deg);
  margin-right: rem(6);
}

.direction_value {
  min-width: rem(118);
  height: rem(52);
  padding: 0 rem(20);
  border-radius: rem(18);
  background: #f6f8f2;
  color: #6e9f21;
  font-size: rem(26);
  font-weight: bold;
  line-height: rem(52);
  text-align: center;
  box-sizing: border-box;
}
</style>
